import axios, { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios';

const axiosRequestConfiguration: AxiosRequestConfig = {
  responseType: 'json',
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: 120000,
};
const instance = axios.create(axiosRequestConfiguration);
const responseBody = <T>(response: AxiosResponse<T>): T => response.data;
const redirectToLogin = (): void => {
  const currentPath = window.location.pathname + window.location.search;
  const encodedReturnUrl = encodeURIComponent(currentPath);
  window.location.href = `/Login?returnUrl=${encodedReturnUrl}`;
};

const handleAxiosError = (error: unknown): void => {
  if (!axios.isAxiosError(error)) return;

  const axiosError = error as AxiosError;
  const method = error.config?.method?.toUpperCase() || 'UNKNOWN METHOD';
  const status = error.response?.status;

  if (status === 401) {
    redirectToLogin();
    return;
  }

  if (status === 500 && !axiosError.response?.data) {
    console.warn(`Error occurred during ${method} request: ${axiosError.message}`);
    throw new Error('Something went wrong on the server. Please try again later.');
  }

  console.error(
    `Error ${status} on ${method} request to ${axiosError.config?.url}:`,
    axiosError.response?.data,
  );
};
export const apiClient = {
  get: async <T>(url: string) => {
    try {
      const response = await instance.get<T>(url);
      return responseBody(response);
    } catch (error) {
      handleAxiosError(error);
      throw error;
    }
  },
  post: async <T, K = object>(url: string, body?: K) => {
    try {
      const response = await instance.post<T, AxiosResponse<T>, K>(url, body);
      return responseBody(response);
    } catch (error) {
      handleAxiosError(error);
      throw error;
    }
  },
  delete: async <T, K = object>(url: string, data?: K) => {
    try {
      const response = await instance.delete<T, AxiosResponse<T>, K>(url, {
        data,
      });
      return responseBody(response);
    } catch (error) {
      handleAxiosError(error);
      throw error;
    }
  },
};
